import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import P from './components/people'

Vue.config.productionTip = false

// Any stored identity (an email, old or current, or a uid) as the person's full
// name; unchanged when nobody has named that account. Reads the store, so a
// template using it re-renders when the directory arrives.
Vue.prototype.$personName = function (identity) {
  return P.nameOf(store.state.directory, identity)
}

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')

// router.beforeEach((to,from,next)=>{
//   if(sessionStorage.user == 'null'){
//   // if(sessionStorage.user == 'nouser'){
//     next('/')
//   }else{
//     next()
//   }
// })

// Registered only on a driver route. The staff app is served from the same
// dist/ on the internal IIS server, and must never acquire a service worker:
// see the comment in public/sw.js.
if ('serviceWorker' in navigator && window.location.hash.indexOf('#/driver') === 0) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {})
  })
}